import "../../sass/views/comingSoon.css";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MenuPath from "../path/MenuPath";
import TitlePage from "../titlePage";

const ComingSoon = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { location } = useSelector((state) => ({
    location: state.homeReducer.location?.data,
  }));

  const handleReturnHome = () => {
    const isRetireesPage = window.location.pathname.includes("/retirees");

    if (isRetireesPage) {
      navigate('/retirees');
    } else {
      const locationId = location?.uniqueNonGuessableId;
      if (locationId) {
        navigate(`/${locationId}`);
      } else {
        navigate('/');
      }
    }
  };

  return (
    <div>
      <Row>
        <MenuPath className="menuPathPortalAdmin" name={t("comingSoon.link")} />
      </Row>
      <Row>
        <Col className="coming-soon-container">
          <div className="coming-soon-content">
            <h1 className="coming-soon-title">{t("comingSoon.title")}</h1>
            <p className="coming-soon-subtitle">{t("comingSoon.subtitle")}</p>
            <button
              className="coming-soon-button"
              onClick={handleReturnHome}
            >
              {t("comingSoon.buttonText")}
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ComingSoon;
